import PropTypes from 'prop-types';
import { useCallback } from 'react';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui'

import { useAppAlert } from '@Components/AppAlert';
import { useGlobalAuthStore } from '@Stores/global/auth';
import history from 'utils/history';

import Form from '../components/Form';
import { TokenProvider, useTokenStore } from '../store';

const TokenForm = () => {
  const { id } = useParams()
  const { collection: { useLoad, item, reset, useSubmit } } = useTokenStore()
  const { auth: { currentSession } } = useGlobalAuthStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)

  const handleClose = useCallback(() => {
    reset()
    history.push(`/settings/tokens`)
  }, [reset])

  const handleSubmit = useSubmit()

  async function handleSubmitAndRedirect(payload) {
    const user = currentSession?.user
    payload.user_id = user.id

    try {
      const { id: tokenId } = await handleSubmit(payload)
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Token ${message}.`)
      history.push(`/settings/tokens/${tokenId}`)
    } catch {
      handleError('Error', `Token was not saved.`)
    }
  }

  if (!item) {
    return null
  }

  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}
      title={item.id ? 'Edit Token' : 'Add Token'}
    >
      <Helmet title="Token" />
      <Form data={item} handleSubmit={handleSubmitAndRedirect} onCancel={handleClose} />
    </DefaultSheet>
  </>
}

TokenForm.propTypes = {
  match: PropTypes.object,
};

export default function TokenFormLayout() {
  return <TokenProvider>
    <TokenForm />
  </TokenProvider>
}
